import {Dimensions, Pressable, ScrollView} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import React, {useRef} from "react"
import CourseCardSmall from "./course-card-small"
import {digg} from "diggerize"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import {SchoolClass} from "models"

/**
 * @typedef {object} RoutesUserSchoolClassesClassSpaceContinueWorkingOnProps
 * @property {unknown} courses
 * @property {unknown} onPressCourseForCourse
 * @property {unknown} schoolClass
 * @property {unknown} startLimitsCacheKey
 * @property {unknown} title
 */

/** @typedef {object} RoutesUserSchoolClassesClassSpaceContinueWorkingOnState */

/**
 * @extends {ShapeComponent<RoutesUserSchoolClassesClassSpaceContinueWorkingOnProps, RoutesUserSchoolClassesClassSpaceContinueWorkingOnState>}
 */
class RoutesUserSchoolClassesClassSpaceContinueWorkingOn extends ShapeComponent {
  scrollValue = 0

  static propTypes = propTypesExact({
    startLimitsCacheKey: PropTypes.string,
    courses: PropTypes.array.isRequired,
    onPressCourseForCourse: PropTypes.func,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired,
    title: PropTypes.string.isRequired
  })

  setup() {
    this.coursesContainerRef = useRef()
  }

  render() {
    const {courses, onPressCourseForCourse, schoolClass, startLimitsCacheKey, title} = this.p

    return (
      <View
        dataSet={this.cache("rootViewDataSet", {
          route: "user/school-classes/class-space/continue-working-on",
          startLimitsCacheKey
        }, [startLimitsCacheKey])}
      >
        <View style={this.titleAndActionsViewStyle ||= {flexDirection: "row", marginLeft: 50}}>
          <Text style={this.continueWorkingOnTextStyle ||= {color: "#2c2c96", fontFamily: "HankenGrotesk", fontSize: 38}}>
            {title}
          </Text>
          <View style={this.actionsContainerStyle ||= {flexDirection: "row", marginLeft: "auto", marginRight: 50}}>
            <Pressable
              onPress={this.tt.onNavigatePreviousPress}
              style={this.navigatePreviousPressableStyle ||= {
                alignItems: "center",
                justifyContent: "center",
                width: 60,
                height: 60,
                border: "1px solid #000",
                borderRadius: 24
              }}
            >
              <Icon color="#000" name="chevron-left" size={24} />
            </Pressable>
            <Pressable
              onPress={this.tt.onNavigateNextPress}
              style={this.navigateNextPressableStyle ||= {
                alignItems: "center",
                justifyContent: "center",
                width: 60,
                height: 60,
                marginLeft: 12,
                border: "1px solid #000",
                borderRadius: 24
              }}
            >
              <Icon color="#000" name="chevron-right" size={24} />
            </Pressable>
          </View>
        </View>
        <View style={this.coursesContainerStyle ||= {marginTop: 20}}>
          <ScrollView horizontal onScroll={this.tt.onScroll} ref={this.tt.coursesContainerRef} scrollEventThrottle={16} showsHorizontalScrollIndicator={false}>
            <View style={this.scrollViewInsideViewStyle ||= {flexDirection: "row", marginLeft: 50}}>
              {courses?.map(({course, schoolClassCourse}) =>
                <View key={`${course.id()}-${schoolClassCourse?.id()}`} style={this.courseContainerStyle ||= {marginRight: 24}}>
                  <CourseCardSmall
                    course={course}
                    onPressCourse={onPressCourseForCourse?.({course, schoolClassCourse})}
                    schoolClass={schoolClass}
                    schoolClassCourse={schoolClassCourse}
                  />
                </View>
              )}
            </View>
          </ScrollView>
        </View>
      </View>
    )
  }

  onNavigatePreviousPress = () => {
    const windowWidth = Dimensions.get("window").width
    const x = this.tt.scrollValue - windowWidth

    this.tt.coursesContainerRef.current.scrollTo({x})
  }

  onNavigateNextPress = () => {
    const windowWidth = Dimensions.get("window").width
    const x = this.tt.scrollValue + windowWidth

    this.tt.coursesContainerRef.current.scrollTo({x, animated: true})
  }

  onScroll = (e) => {
    this.scrollValue = digg(e, "nativeEvent", "contentOffset", "x")
  }
}

export default memo(shapeComponent(RoutesUserSchoolClassesClassSpaceContinueWorkingOn))
